import type { FaireProductEntity } from "../../entity_types/product";

export const p_p6h9ybtteq: FaireProductEntity = {
  token: "p_p6h9ybtteq",
  type: "product",
  name: "Cutest Pumpkin In The Patch Long Sleeve Romper - Fall Baby",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/bc63c0a394918bd8b79b51ad8562849181dd8a7fc380d01f23e87ffa8feefc6b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/13cc619ca51d3823546459a8418209398cd360fc6df9033476f372b6e3b4ba22.jpeg",
    "https://cdn.faire.com/fastly/5315e628bf88c8a2f1ba4ad05493fac8634b2c3fa95391401440ee31d8d88c46.jpeg",
  ],
  priceDollars: 16,
  description:
    "The Cutest Pumpkin In The Patch Long Sleeve Romper is a fun and cute romper for babies celebrating Fall!\n\nFeatures:\n * Romper Color: Natural \n * Graphic Color: Burnt Orange \n * Material: 100% Cotton \n * Features: Tagless inside neck label for an itch-free wear; 3 snap closure; cuffed sleeves; trendy bubble style \n * Fit: Infant Unisex \n * Care: Machine washable, tumble dry low, wash with like colors \n\nEach romper is hand pressed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:23.135Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
